// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { getDisplayName } from '../../user/userUtil';

// Selectors
import { getCurrentBoard } from '../../element/selectors/currentBoardSelector';
import { getUsers } from '../../user/usersSelector';
import { getWelcomeMessageModifier } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import UserAvatar from '../../components/userAvatar/UserAvatar';

// Styles
import './WelcomeMessageModifier.scss';

const mapStateToProps = createSelector(getCurrentBoard, getUsers, (currentBoard, users) => {
    const modifierId = getWelcomeMessageModifier(currentBoard);
    const modifier = users.get(modifierId);

    return {
        modifier,
    };
});

const WelcomeMessageModifier = (props) => {
    const { modifier } = props;

    if (!modifier) return null;

    return (
        <div className="WelcomeMessageModifier">
            <UserAvatar user={modifier} size={24} />
            <span className="name">{getDisplayName(modifier)}</span>
        </div>
    );
};

WelcomeMessageModifier.propTypes = {
    modifier: PropTypes.object,
};

export default connect(mapStateToProps)(WelcomeMessageModifier);
